import Script from 'next/script';

export const PushlyScript = () => (
  <>
    <Script
      async
      id='pushly'
      src={`https://cdn.p-n.io/pushly-sdk.min.js?domain_key=${process.env.NEXT_PUBLIC_PUSHLY_DOMAIN_KEY}`}
    />
    <Script
      async
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Ok
      dangerouslySetInnerHTML={{
        __html: `
          window.PushlySDK = window.PushlySDK || [];
          function pushly() { window.PushlySDK.push(arguments) }
          pushly('load', {
            domainKey: '${process.env.NEXT_PUBLIC_PUSHLY_DOMAIN_KEY}',
            sw: '/assets/service-workers/worker.js'
          });
        `,
      }}
      id='pushly-sdk-01'
    />
  </>
);
